import React from "react";
import { IControlStyles, useControlStyles } from "../.";
import { ComponentProps, ControlInput, ControlTemplateProps } from "../misc/controlInput";

export interface ControlUrlProps extends ControlTemplateProps {
    
}

export const ControlUrl: React.FC<ControlUrlProps> = (props) => {
    const styles: IControlStyles = props.controlStyles ??  useControlStyles();
    
    return (
        <ControlInput type="url" {...ComponentProps(props)} style={{ ...styles.url ?? styles.text ?? styles.input, ...props.style }} />        
    );
};